
import {Button} from "@progress/kendo-react-buttons";
import "./AdminManagementButton.scss";
import  { useNavigate}  from "react-router-dom";


const AdminManagementButton = () => {

    const navigate = useNavigate();

    return (

        <Button className={"adminButton"} fillMode={"link"} onClick={() => navigate("/state/admin-management")}>
            <span className="k-icon k-i-settings">&nbsp;</span>View Admin Page
        </Button>
    );
};
export default AdminManagementButton